import { render, staticRenderFns } from "./staff_update.vue?vue&type=template&id=6b423d1f"
import script from "./staff_update.vue?vue&type=script&lang=js"
export * from "./staff_update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports